import { Renderer2Interceptor } from '@angular/core/src/render/api';
import { VisualizerService } from '../../../services/visualizer.service';
import { Component, ElementRef, EventEmitter, Input, OnInit, Output, Renderer, Renderer2, ViewChild, OnDestroy } from '@angular/core';
import { Color, ProjectImage, BoardImage } from '../../../models/color.model';
import { Canvas, CanvasImage } from '../../../models/canvas.model';
import { Subscription } from 'rxjs/Rx';
import { QaService } from '../../../services/qa.service';
import { StartupService } from '../../../services/startup.service';
import { QuestionTypeEnum } from '../../../models/question-type';

@Component({
  selector: 'app-zoom',
  templateUrl: './zoom.component.html',
  styleUrls: ['./zoom.component.scss']
})
export class ZoomComponent implements OnInit, OnDestroy {

  @ViewChild('board') board;
  @ViewChild('canvasBoard') canvasBoard;
  @ViewChild('canvasBoardSwatch') canvasBoardSwatch;
  canvasModel: Canvas;
  color: Color;
  colorSubscription: Subscription;
  zoomStateSubscription: Subscription;
  hideZoom: boolean;
  currentImage: BoardImage;
  opacityName: string;
  canvasSwatchModel: Canvas;
  showCanvas: boolean;

  constructor(private service: VisualizerService,
    private renderer: Renderer2,
    private qaService: QaService,
    private startupService: StartupService) { }

  ngOnInit() {
    this.colorSubscription = this.service.selectedColor.subscribe(c => {
      this.color = c;
      this.getBoardImage();
      this.paintBoard();
    });
    this.zoomStateSubscription = this.service.zoomState.subscribe (s => {
      this.hideZoom = s;
    });
    this.showCanvas = true;
    this.prepareBoardCanvas();
  }
  getColorName() {
    return this.color === null ? '-' : this.color.Name.toUpperCase();
  }
  getBoardImage() {
    const woodType = this.startupService.startupData.QuestionTypes.find(d => d.Name === QuestionTypeEnum.WoodType).ItemGuid;
    const selectedWoodType = this.qaService.answers.selectedAnswers.find(c => c.QuestionType === woodType);

    if (selectedWoodType != null && this.color != null) {
      const img = this.service.visualizerData.BoardImages.find(c =>
        c.Opacity === this.color.Opacity &&
        c.WoodType === selectedWoodType.WoodTypeFilter
      );
      this.currentImage = img;

      if (img === null) {
        this.canvasModel.colorCanvas(`rgb(${this.color.R},${this.color.G},${this.color.B}`);
      }
    }
  }

  showZoom() {
    if (this.color != null) {
      this.showCanvas = false;
      this.service.setZoomState(false);
    }
  }

  ngOnDestroy(): void {
    this.qaService.paintedBoard = this.canvasModel.canvas.toDataURL();
    this.colorSubscription.unsubscribe();
    this.zoomStateSubscription.unsubscribe();
  }

  hide(isHidden: boolean) {
    this.hideZoom = isHidden;
    this.service.setZoomState(isHidden);
    this.showCanvas = true;
  }

  prepareBoardCanvas() {
    const canvasWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    const canvasHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
    this.canvasBoard.nativeElement.width = canvasWidth;
    this.canvasBoard.nativeElement.height = canvasHeight;
    this.canvasModel = new Canvas(canvasWidth, canvasHeight, this.canvasBoard.nativeElement);
    this.canvasModel.colorCanvas('#000000');

    this.canvasBoardSwatch.nativeElement.width = 900;
    this.canvasBoardSwatch.nativeElement.height = 70;
    this.canvasSwatchModel = new Canvas(this.canvasBoardSwatch.nativeElement.width, this.canvasBoardSwatch.nativeElement.height, this.canvasBoardSwatch.nativeElement);
    this.canvasSwatchModel.colorCanvas('#000000');
  }

  paintBoard() {
    let that = this;
    if (this.currentImage != null) {
      let swatchImage = new CanvasImage(this.currentImage.BoardSwatchImage, () => { swatchImage.drawOnCenter(this.canvasSwatchModel), this.canvasSwatchModel.blendMultiplyCustom(that.color); });
      let image = new CanvasImage(this.currentImage.BoardImage, () => { image.drawOnCenter(this.canvasModel); this.canvasModel.blendMultiplyCustom(that.color); });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/visualizer/zoom/zoom.component.ts